import React, { Component } from "react";
import { Switch } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import routes from "./components/pages/index";
import { firestore, auth } from "./helpers/Firebase";
import ProtectedRoute from "./helpers/ProtectedRoute";

import "react-quill/dist/quill.snow.css";
import "dropzone/dist/min/dropzone.min.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, currentUser: undefined };
  }

  componentDidMount() {
    // FirebaseRemoved
    // this.unsubscribe = auth.onAuthStateChanged((user) => {
    //   if (user) {
    //     firestore
    //       .doc(`Web/Corporate/Admins/${user.uid}`)
    //       .get()
    //       .then((snapshot) => {
    //         if (snapshot.exists) {
    //           this.setState({
    //             loading: false,
    //             currentUser: { ...user, MetaData: snapshot.data() },
    //           });
    //         } else {
    //           this.setState({
    //             loading: false,
    //             currentUser: { ...user },
    //           });
    //         }
    //       });
    //   } else {
    //     this.setState({
    //       loading: false,
    //     });
    //   }
    // });
  }

  componentWillUnmount() {
    // FirebaseRemoved
    // this.unsubscribe();
  }

  render() {
    const { loading, currentUser } = this.state;

    return (
      <BrowserRouter>
        <Switch>
          {routes.map((data, idx) => (
            <ProtectedRoute
              exact
              loading={loading}
              path={data.path}
              component={data.component}
              key={idx}
              authProtected={data.authProtected}
              currentUser={currentUser}
            />
          ))}
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
